import config from "../constants/config";

export const FETCH_USER_DATA = "FETCH_USER_DATA";
export const RESET_FETCHED = "RESET_FETCHED";
export const SUBMIT_EMAIL_SUCCESS = "SUBMIT_EMAIL_SUCCESS";
export const SUBMIT_EMAIL_FAIL = "SUBMIT_EMAIL_FAIL";

export const fetchUserData = () => async (dispatch, getState) => {
  const state = getState();
  const { userID, token } = state.auth;
  let userData = {};

  try {
    // if logged in, fetch data and save
    if (userID) {
      // fetch data. TODO: condense into one fetch function to reduce server load
      const [
        packagesRes,
        accountRes,
        lockersRes,
        merchantRes
      ] = await Promise.all([
        fetch(
          `${config.API_ENDPOINT}/api/packages/${userID}?token=${token}`
        ).then(res => res.json()),
        fetch(
          `${config.API_ENDPOINT}/api/account/${userID}?token=${token}`
        ).then(res => res.json()),
        fetch(
          `${config.API_ENDPOINT}/api/locations/${userID}?token=${token}`
        ).then(res => res.json()),
        fetch(
          `${
            config.API_ENDPOINT
          }/api/merchant/fetchData/${userID}?token=${token}`
        ).then(res => res.json())
      ]);

      userData = {
        packages: packagesRes,
        account: accountRes,
        lockers: lockersRes.status >= 400 ? [] : lockersRes,
        merchant: merchantRes.status >= 400 ? undefined : merchantRes.payload
      };
    }
  } catch (error) {
    userData = error;
  }

  dispatch({
    type: FETCH_USER_DATA,
    payload: userData
  });
};

export const resetFetched = () => dispatch => {
  dispatch({ type: RESET_FETCHED });
};
